import i18n from 'i18next';
import { FuelType } from '../../resources/base/models/vehicleTypes';
import { Yup } from '../../services/common/validation';

export const RegistrationCostPopupModalSchema = (fuelType?) => {
  const initialForm = Yup.object().shape({
    inputWeight: Yup.number(),
    weightTax: Yup.number(),
    malusBeforeTax: Yup.number(),
    lcvExtraBeforeTax: Yup.number(),
  });
  const autonomyValueSchemaNonRequired = Yup.object().shape({
    autonomyValue: Yup.number(),
  });
  const autonomyValueSchemaRequired = Yup.object().shape({
    autonomyValue: Yup.number().required(() => i18n.t('step1:configVehicle:mandatoryField')),
  });
  if (fuelType === FuelType.Hybrid) {
    return initialForm.concat(autonomyValueSchemaRequired);
  }
  return initialForm.concat(autonomyValueSchemaNonRequired);
};
